import { useState, useEffect } from 'react'
import { Scrollama, Step } from 'react-scrollama'
import Stage from './Stage'

const ScrollyOne = ({ section, clicked }) => {
  const [currentStepIndex, setCurrentStepIndex] = useState(-1)
  const [direction, setDirection] = useState(null)
  const [fade, setFade] = useState(false)

  const sectionNum = 1
  useEffect(() => {
    if (section <= sectionNum || !section) {
      setFade(false)
    } else setFade(true)
    if (section === sectionNum) setCurrentStepIndex(0)
    else setCurrentStepIndex(-1)
  }, [section, clicked])

  // This callback fires when a Step hits the offset threshold. It receives the
  // data prop of the step, which in this demo stores the index of the step.
  const onStepEnter = ({ data, direction }) => {
    setCurrentStepIndex(data)
    setDirection(direction)
    setFade(false)
  }

  const onStepExit = ({ data, direction }) => {
    if (data === 0 && direction === 'up') setCurrentStepIndex(-1)
    if (data === 2 && direction === 'down') setFade(true)
  }

  const jobContent = [
    "The startup rate is one of the most important indicators of economic dynamism. But how do new firms fuel a healthy job market? The answer is simple: they're the true engine of job creation. <br/><br/>First, consider that established firms grow and decline at predictable rates, with their job gains and losses canceling each other out in most years.",
    'Jobs from successful startups, however, are pure gains. For this reason, jobs from young firms account for the bulk of net job creation. Between 1992 and 2007, startups generated an average of nearly 2.8 million new jobs each year. ',
    'However, since the Great Recession, that total has fallen nearly 20 percent to about 2.3 million.'
  ]

  return (
    <>
      <div className="scrolly-container">
        <Stage
          currentStepIndex={currentStepIndex}
          direction={direction}
          chart={'jobs'}
          fade={fade}
        />
        <div className="scroller">
          <Scrollama
            onStepEnter={onStepEnter}
            onStepExit={onStepExit}
            offset={0.8}
            //debug
          >
            {jobContent.map((item, stepIndex) => (
              <Step data={stepIndex} key={stepIndex}>
                <div className={`step-container ${stepIndex === 2 && 'last'}`}>
                  <div className={`step-content step-${currentStepIndex}`}>
                    {stepIndex === 0 ? (
                      <div dangerouslySetInnerHTML={{ __html: item }} />
                    ) : (
                      item
                    )}
                  </div>
                </div>
              </Step>
            ))}
          </Scrollama>
        </div>
      </div>
    </>
  )
}

export default ScrollyOne
